import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {FormularioAComponent} from "./components/formulario-a/formulario-a.component";
import {FormularioBComponent} from "./components/formulario-b/formulario-b.component";
import {FormularioCComponent} from "./components/formulario-c/formulario-c.component";
import {TramitesDisponiblesComponent} from "./components/tramites-disponibles/tramites-disponibles.component";
import {FormularioDComponent} from "./components/formulario-d/formulario-d.component";
import { FormularioIComponent } from './components/formulario-i/formulario-i.component';

const routes: Routes = [
    {path: '', component: TramitesDisponiblesComponent},
    {path: 'completar/fa/:idTramite/:idProyecto', component: FormularioAComponent},
    {path: 'completar/fb/:idTramite/:idProyecto', component: FormularioBComponent},
    {path: 'completar/fc/:idTramite/:idProyecto', component: FormularioCComponent},
    {path: 'completar/fd/:idTramite/:idProyecto', component: FormularioDComponent},
    {path: 'completar/fi/:idTramite/:idProyecto', component: FormularioIComponent}

]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TramitesRoutingModule {
}
